import React, { useState, useEffect } from "react";

export const svg = `<svg width="48" height="48" viewbox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.009 7.492c.881 5.13 9.351 10.274 13.476 12.205-2.825 3.361-2.939 10.48 1.214 13.73 3.322 2.599 3.475 5.226 3.22 7.74-2.033-4.972-5.009-6.733-6.92-7.74-.312 1.412.225 3.098.677 3.813-4.542-2.305-8.249-9.803-8.249-12.43.956 1.189 2.119 1.366 2.693 1.453l.104.016c0-1.158-.198-2.655-2.966-5.34-3.047-2.953-4.38-8.927-3.249-13.447ZM30.751 25.94a6.639 6.639 0 1 1-13.278 0 6.639 6.639 0 0 1 13.278 0Zm.672-6.243c4.125-1.93 12.594-7.074 13.476-12.205 1.13 4.52-.202 10.494-3.25 13.448-2.768 2.684-2.966 4.18-2.966 5.34l.104-.017c.575-.087 1.738-.264 2.693-1.453 0 2.627-3.706 10.125-8.249 12.43.452-.715.989-2.4.678-3.813-1.912 1.007-4.887 2.768-6.921 7.74-.255-2.514-.102-5.141 3.22-7.74 4.153-3.25 4.04-10.368 1.215-13.73Z" fill="#CD8837"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
